(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/components/play-own-button.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/components/play-own-button.js');

'use strict';

const Button = svs.ui.ReactButton;
const PlayOwnButton = () => {
  const handleClick = () => {
    svs.utils.url.navigate("eurojackpot/spela?rader=1");
  };
  return React.createElement("div", {
    className: "play-own-button"
  }, React.createElement(Button, {
    className: "btn",
    onClick: () => handleClick(),
    type: "button"
  }, " Spela egna nummer"));
};
setGlobal('svs.eurojackpot.react.components', {
  PlayOwnButton
});

 })(window);